/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2018 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import React from 'react';

import { connect } from '@airglow/store-redux';
import SessionList from '../../ui/session-list';

import SessionCreateModalContainer from '../../session-create';

import { expiringSessions } from '../../casing/data/feature.flags';
import { showCreate } from '../../casing/data/prefabs';
import { navigateToSessionView } from '../../common/actions';
import BoxIllustration from '../../../images/BoxIllustration.svg';
import { deleteSession, searchSessions } from '../actions';
import { sessionListSearch, sessionListTab, showDelete } from '../data/prefabs';
import { sessionsTable } from '../data/table.prefabs';
import { selectSessionsLoading } from '../selectors';

const mapState = (state, props) => ({
  createWidget: <SessionCreateModalContainer {...props} />,
  deleting: showDelete.isOn(state),
  emptyImage: <img src={BoxIllustration} alt="" />,
  expiringSessions: expiringSessions(state),
  loading: selectSessionsLoading(state),
  search: sessionListSearch.value(state),
  selectedTabIndex: sessionListTab.value(state),
  ...sessionsTable.state(state)
});

const mapHandlers = dispatch => ({
  onCancelDelete: () => showDelete.doClose(dispatch),
  onChangeSearch: (v) => {
    dispatch(sessionListSearch.changeAction(v));
    dispatch(searchSessions());
  },
  onClickCreate: () => showCreate.doOpen(dispatch),
  onConfirmDelete: () => {
    dispatch(deleteSession());
    showDelete.doClose(dispatch);
  },
  onNameClick: ({ uuid }, e) => {
    e.stopPropagation();
    dispatch(navigateToSessionView({ session: uuid }));
  },
  onSelectTab: v => dispatch(sessionListTab.changeAction(v)),
  onActionBarClick: (v) => {
    if (v === 'delete') {
      showDelete.doOpen(dispatch);
    }
  },
  onActionBarChange: () => dispatch(sessionsTable.deselectRowsAction()),
  ...sessionsTable.handlers(dispatch)
});

export default connect(mapState, mapHandlers)(SessionList);
